export const getUserPreferenceId = state => state?.userPreference?.id
export const getUserPreferenceUserId = state => state?.userPreference?.user_id
export const getUserPreferenceUnitOfMeasurement = state => state?.userPreference?.unit_of_measurement
export const getUserPreferenceUnitOfMeasurementDisplay = state => state?.userPreference?.unit_of_measurement?.name
export const getUserPreferenceActive = state => state?.userPreference?.active
export const getUserPreferenceCurrencySymbol = state => state?.userPreference?.currency?.symbol
